import $, { ready } from "jquery";
import axios from "axios";
import Swal from 'sweetalert2';


$('#suscribe-form-events').submit(function(ev){
    $('#submit-button').prop('disabled',true);
    ev.preventDefault();
    $.post({
        url:'/',
        dataType:'json',
        data:$(this).serialize(),
        success: function(response){
            if(response.success){
                Swal.fire(
                    'Suscripción exitosa',
                    'Te has suscrito exitosamente, ahora recibirás notificaciones sobre nuestros eventos.',
                    'success'
                );
                $("#suscribe-form-events")[0].reset();
            }else{
                Swal.fire(
                    'Ha ocurrido un error',
                    'Verifica tu información o inténtalo más tarde. No se ha podido realizar tu petición.',
                    'error'
                );
            }
            $('#submit-button').prop('disabled',false);
        }
    });
});

$(".events-filters__filter-item select").change(function () {
    let query = "?";
    if ($(this).data("filtro") == "tipo") {
      query += "tipo=" + $(this).val();
    } else {
      $(".events-filters__filter-item select").each(function () {
        let filtro = $(this).data("filtro");
        let valor = $(this).val();
        if (valor && valor !== "0") {
          let filter_string = filtro + "=" + valor + "&";
          query = query + filter_string;
        }
      });
    }
    // console.log(query)
    window.location.href = query == "?linea=0" ? location.pathname : query;
  });
  
  $(document).ready(function () {
    // $('.products-grid__counter').text( $('.products-grid .product-card__container:visible').length )
    if (document.querySelector(".products-grid__counter")) {
      $(".products-grid__counter").text(contProduct);
    }
});

var filterProximos = document.getElementById('eventos-proximos');
var selectedCards = document.querySelectorAll('.eventos-lasted-card');

if( filterProximos ) {
    filterProximos.addEventListener('change', function() {
        if ( filterProximos.checked ) {
            for(let item of selectedCards) {
                item.classList.toggle('d-none');
            }
        } else {
            for(let item of selectedCards) {
                item.classList.toggle('d-none');
            }
        }
    });
}

    var evImage = document.querySelector('.eventos-image');
    var evContainer = document.querySelector('.eventos-image-container');
    var evBody = document.querySelector('.eventos-body');
    if ( evImage ){
        evContainer.style.height = evImage.clientHeight / 2 + 'px';
        evBody.style.marginTop = evImage.clientHeight / 2 + 'px';
    }
    window.onload = function () {
        var evImage = document.querySelector('.eventos-image');
        var evContainer = document.querySelector('.eventos-image-container');
        var evBody = document.querySelector('.eventos-body');
        if ( evImage ){
            evContainer.style.height = evImage.clientHeight / 2 + 'px';
            evBody.style.marginTop = evImage.clientHeight / 2 + 'px';
            window.addEventListener('resize', (event) => {
                evImage = document.querySelector('.eventos-image');
                evContainer = document.querySelector('.eventos-image-container');
                evBody = document.querySelector('.eventos-body');
                evContainer.style.height = evImage.clientHeight / 2 + 'px';
                evBody.style.marginTop = evImage.clientHeight / 2 + 'px';
            });
        }
    }

    $(document).on("click", ".toggle-search-event", function () {
        $("#EventSearchToggle").toggleClass("search-event");
        $("#buscar_event").slideToggle(150);
    });